<template>
  <b-modal id="updateUserDataAddressModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.userdataaddress.updateUserDataAddressHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="userDataAddress">
      <b-col>
        <UserDataAddressUpdate :userDataAddressId="userDataAddress['@id']"></UserDataAddressUpdate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import UserDataAddressUpdate from '../Update.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'UpdateUserDataAddressModal',
  components: {
    UserDataAddressUpdate
  },
  computed: {
    show () {
      return this.$store.state.modals.userdataaddress.update.show
    },
    userDataAddressPivot () {
      return this.$store.state.modals.userdataaddress.update.userDataAddressPivot
    },
    close () {
      return this.$store.state.modals.userdataaddress.update.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'userDataAddressPivot': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      userDataAddress: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.userDataAddressPivot) {
        this.userDataAddress = Object.assign({}, this.userDataAddressPivot)
        this.$store.state.modals.userdataaddress.update.show = 0
        this.$store.state.modals.userdataaddress.update.userDataAddressPivot = null
        this.$bvModal.show('updateUserDataAddressModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.userdataaddress.update.close = 0
        this.$bvModal.hide('updateUserDataAddressModal')
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
